(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["black-week-collection-banner"]) return;
  try {
    
document.addEventListener("shopify:section:load", () => {
        document.getElementById("FilterGridWrapper").appendChild(document.getElementById("BlackWeekBanner"));
        document.getElementById("BlackWeekBanner").classList.remove("hidden");
    }
);
document.addEventListener("shopify:section:unload", () => {
    document.getElementById("BlackWeekBanner").remove();
});
document.addEventListener("DOMContentLoaded", () => {
        document.getElementById("FilterGridWrapper").appendChild(document.getElementById("BlackWeekBanner"));
        document.getElementById("BlackWeekBanner").classList.remove("hidden");
    }
);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["featured-collections"] && !Shopify.designMode) return;
  try {
    
function initialize(){
  document.querySelectorAll(".collection-selection").forEach((collectionSelection)=>{
    collectionSelection.querySelectorAll("[data-show-collection]").forEach((target)=>{
      target.addEventListener("click",()=>{
        collectionSelection.querySelectorAll(".collection-block").forEach((block,i)=>{
          block.classList.toggle("active",block.dataset.collectionId == target.dataset.showCollection);
        });
        collectionSelection.querySelectorAll("[data-show-collection]").forEach((block,i)=>{
          block.classList.toggle("active",block.dataset.showCollection == target.dataset.showCollection);
        });
      });
      target.addEventListener("keydown",(e)=>{
        if (event.key != "Enter") { return }

        collectionSelection.querySelectorAll(".collection-block").forEach((block,i)=>{
          block.classList.toggle("active",block.dataset.collectionId == target.dataset.showCollection);
        });
        collectionSelection.querySelectorAll("[data-show-collection]").forEach((block,i)=>{
          block.classList.toggle("active",block.dataset.showCollection == target.dataset.showCollection);
        });
      });
      target.classList.remove("hidden");
    })
  });
}
document.addEventListener("DOMContentLoaded", () => initialize());
document.addEventListener('shopify:section:load', () => initialize());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 1279px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid-grouped"]) return;
  try {
    
class InfiniteScroll extends HTMLElement {
  constructor() {
    super();
    this.productsContainerSelector = this.getAttribute('data-products-container');
    this.paginationSelector = this.getAttribute('data-pagination-selector');
    this.nextPageSelector = this.getAttribute('data-next-page-selector');
    this.productsContainerEl = this.querySelector(this.productsContainerSelector);
    this.paginationEl = this.querySelector(this.paginationSelector);
    this.loadingIndicator = this.querySelector('.loading-overlay-wrapper');

    if (!this.productsContainerEl || !this.paginationEl) {
      return;
    }

    try {
      this.observer = this.registerObserver(this.loadNextPage.bind(this));
      this.observer.observe(this.paginationEl);
      this.paginationEl.style.visibility = 'hidden';
    } catch (error) {}

  }

  registerObserver(callback) {
    let callbackIsRunning = false
    return new IntersectionObserver(function (entries) {
      if (entries[0].isIntersecting && !callbackIsRunning) {
        callbackIsRunning = true;
        callback()
          .then(_ => callbackIsRunning = false)
          .catch(_ => callbackIsRunning = false);
      }
    })
  }

  loadNextPage() {
    const nextPageEl = this.paginationEl.querySelector(this.nextPageSelector);
    if (!nextPageEl) {
      this.observer.disconnect();
      return Promise.resolve();
    }
    const nextPageUrl = nextPageEl.getAttribute('href');
    this.loadingIndicator.classList.remove('hidden');
    return fetch(nextPageUrl)
      .then(result => {
        this.loadingIndicator.classList.add('hidden')
        if (!result.ok) {
          throw(result.statusText);
        }
        return result.text()
      })
      .then(this.handleNextPage.bind(this))
  }

  handleNextPage(nextPageContent) {
    const nextPageHtml = new DOMParser().parseFromString(nextPageContent, 'text/html')
    const nextPageProducts = nextPageHtml.querySelector(this.productsContainerSelector)
    if (!nextPageProducts) {
      console.warn('Infinite scroll: Could not find any products in next page', nextPageHtml);
      return;
    }
    this.productsContainerEl.insertAdjacentHTML('beforeend', nextPageProducts.innerHTML);
    window.postMessage({
      type: 'next_page_loaded',
      selector: this.id,
    }, '*');
    const nextPagePagination = nextPageHtml.querySelector(this.paginationSelector);
    if (!nextPagePagination) {
      return;
    }
    this.paginationEl.innerHTML = nextPagePagination.innerHTML;
  }
}

customElements.define('infinite-scroll', InfiniteScroll);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["neocom-embedded-collection-banner"]) return;
  try {
    
document.addEventListener("shopify:section:load", () => {
        document.getElementById("product-grid").appendChild(document.getElementById("NeocomCollectionBanner"));
        document.getElementById("NeocomCollectionBanner").classList.remove("hidden");
    }
);
document.addEventListener("shopify:section:unload", () => {
    document.getElementById("NeocomCollectionBanner").remove();
});
document.addEventListener("DOMContentLoaded", () => {
        document.getElementById("product-grid").appendChild(document.getElementById("NeocomCollectionBanner"));
        document.getElementById("NeocomCollectionBanner").classList.remove("hidden");
    }
);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-navigation"]) return;
  try {
    

function setActiveLink(links, activeLink){
    links.forEach((link) => link.classList.remove("active"));
    if (activeLink) {
      activeLink.classList.add("active");
      activeLink.parentElement.scrollLeft = activeLink.offsetLeft;
    }
}
function preventStickyHeaderShowing(){
  let stickyHeader = document.querySelector('sticky-header');
  if(stickyHeader) {
    stickyHeader.dispatchEvent(new Event('preventHeaderReveal'));
  }
}

function setupNavigation(navigation) {
  const sections = Array.from(navigation.parentElement.parentElement.querySelectorAll(".shopify-section"));
  const sectionOffset = sections.indexOf(navigation.parentElement)

  const links = Array.from(navigation.querySelectorAll("[data-targets]"));
  const sectionLinkMapping = {};

  for(let link of links){
    for(let targetSectionIdx of link.dataset.targets.split(",")){
      let target = sections[sectionOffset + parseInt(targetSectionIdx)];
      sectionLinkMapping[target.id] = link;
      if (!link.dataset.target){ link.dataset.target = "#" + target.id; }
    }
    link.addEventListener("click", () => {
      setActiveLink(links, link);
      preventStickyHeaderShowing();
      window.scrollTo(0, document.querySelector(link.dataset.target).offsetTop - navigation.clientHeight);
      //document.querySelector(link.dataset.target).scrollIntoView();
    });
  }
  navigation.classList.remove("hidden");

  let scrollRightButton = navigation.querySelector(".scroll-right-icon");
  if (scrollRightButton){
    scrollRightButton.addEventListener("click", () => {
      let active_link_index = links.findIndex((link) =>
          link.classList.contains("active")
        );

      if (active_link_index == -1) {
        for(let link of links){
          if(link.offsetLeft > navigation.scrollLeft){
            navigation.scrollLeft = link.offsetLeft;
            break;
          }
        }
      }
      else if(active_link_index+1 < links.length){
        links[active_link_index+1].click();
      }
    })
  }

  if ("IntersectionObserver" in window) {
    const io = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          sectionLinkMapping[entry.target.id].classList.toggle("visible", entry.isIntersecting);
        });
        let first_visible_link = links.find((link) =>
          link.classList.contains("visible")
        );
        setActiveLink(links, first_visible_link);
      },
      {
        rootMargin: "-200px 0px 0px 0px",
        threshold: [0, 0.01, 0.025, 0.05, 0.075, 0.1, 0.5, 0.75, 0.95, 1]
      }
    );
    for(let link of links){
      for(let targetSectionIdx of link.dataset.targets.split(",")){
        let target = sections[sectionOffset + parseInt(targetSectionIdx)];
        io.observe(target);
      }
    }

    document.addEventListener("shopify:section:unload", () => io.disconnect(), { once: true });

  }
}
document.addEventListener("DOMContentLoaded", () =>
  document.querySelectorAll(".product-navigation").forEach(setupNavigation)
);

document.addEventListener("shopify:section:load", () =>
  document.querySelectorAll(".product-navigation").forEach(setupNavigation)
);

function updateNavigationPosition() {
  let product_navigations = document.querySelectorAll(".product-navigation");
  for (let product_navigation of product_navigations){
    product_navigation.classList.toggle(
      "product-navigation--mobile",
      product_navigation.scrollWidth > product_navigation.clientWidth
    );
  }
}
document.addEventListener("DOMContentLoaded", updateNavigationPosition);
window.addEventListener("resize", updateNavigationPosition);
document.addEventListener("shopify:section:load", updateNavigationPosition);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();

      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);

        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');

            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
              window.postMessage({
                type: 'product_recommendations_loaded',
                selector: this.id,
              }, '*');
            }

            if (html.querySelector('.grid__item')) {
              this.classList.add('product-recommendations--loaded');
            }
          })
          .catch(e => {
            console.error(e);
          });
      }

      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }

  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["quotes"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll(".sg__quotes").forEach(quotes => {
    const quotesContainer = quotes.querySelector(".sg__quotes-container")
    const quotesSelector = quotes.querySelector(".sg__quotes-selector")
    const counter = quotes.querySelector(".sg__quotes-progress .current")

    let current_index = 1
    const interval = parseInt(quotes.dataset.interval)*1000;

    const switch_to_index = function(index) {
        quotesContainer.querySelectorAll(".active")
            .forEach(quote => quote.classList.remove("active"))
        quotesContainer.querySelector(`div:nth-child(${index})`).classList.add("active");

        quotesSelector.querySelectorAll(".active")
            .forEach(link => link.classList.remove("active"))
        quotesSelector.querySelector(`a:nth-child(${index})`).classList.add("active");

        counter.textContent = index
        current_index = index
        // console.log(index)
    }

    //setInterval(()=>switch_to_index((current_index % quotesContainer.children.length) + 1), interval)

    quotesSelector.querySelectorAll("a").forEach(a => a.addEventListener("click", () => switch_to_index(parseInt(a.dataset.index))))
})

  } catch(e) { console.error(e); }
})();
})();
